// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.APu9_M1MYhkJun {
  position: relative;
  flex-grow: 1;
  padding: var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-200, 6px);
  color: var(--ds-icon, #44546f);
}
.APu9_M1MYhkJun.ntjGJlJUmpvLht {
  background-color: var(--ds-background-selected, #e9f2ff);
  color: var(--ds-icon-selected, #0c66e4);
}
.APu9_M1MYhkJun.ntjGJlJUmpvLht:hover {
  background-color: var(--ds-background-selected-hovered, #cce0ff);
}
.APu9_M1MYhkJun.ntjGJlJUmpvLht:active {
  background-color: var(--ds-background-selected-pressed, #85b8ff);
}
.APu9_M1MYhkJun.mxfcBipsk9KCjR {
  background-color: var(--ds-background-brand-bold, #0c66e4);
  color: var(--ds-icon-inverse, #ffffff);
}
.APu9_M1MYhkJun.mxfcBipsk9KCjR:hover {
  background-color: var(--ds-background-brand-bold-hovered, #0055cc);
}
.APu9_M1MYhkJun.mxfcBipsk9KCjR:active {
  background-color: var(--ds-background-brand-bold-pressed, #09326c);
}
.APu9_M1MYhkJun.Nv8oAmNcmfqNc4 {
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 10px);
}
.ZUA8nVTOtnV2wD {
  display: block;
  position: absolute;
  bottom: var(--ds-space-0, 0);
  width: 12px;
  height: 2px;
  margin: var(--ds-space-0, 0) auto;
  background-color: var(--ds-icon-selected, #0c66e4);
}
`, ""]);
// Exports
export var button = `APu9_M1MYhkJun`;
export var selected = `ntjGJlJUmpvLht`;
export var primary = `mxfcBipsk9KCjR`;
export var withLabel = `Nv8oAmNcmfqNc4`;
export var indicator = `ZUA8nVTOtnV2wD`;
export default ___CSS_LOADER_EXPORT___;
